import script from "./ReviewReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviewReport.vue?vue&type=script&setup=true&lang=ts"

import "./ReviewReport.vue?vue&type=style&index=0&id=7da1ceb6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7da1ceb6"]])

export default __exports__